/**
 * The Simple Coffee mark.
 *
 * PLACEHOLDER: this is a faithful rebuild from the written description of the
 * official icon (white cup, charcoal outline, eyes, handle, yellow shape above
 * the cup, flat, rounded, turquoise ground). When the owner's original vector
 * file lands, replace the paths here and in `public/favicon.svg` with it.
 * Do not redesign the mark (Rule 18).
 */
export interface SimpleCoffeeMarkProps {
  /** Rendered width and height in pixels. */
  size?: number;
  /** Draw the turquoise rounded square behind the cup. */
  withBackground?: boolean;
  /** Accessible name; pass null for a purely decorative mark. */
  title?: string | null;
  className?: string;
}

export function SimpleCoffeeMark({
  size = 40,
  withBackground = true,
  title = 'Simple Coffee',
  className,
}: SimpleCoffeeMarkProps) {
  const decorative = title === null;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role={decorative ? 'presentation' : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : title}
      focusable="false"
    >
      {withBackground && <rect width="64" height="64" rx="14" fill="var(--color-primary)" />}
      <path
        d="M32 12c3.6 0 6 2.1 6 4.7 0 2.4-2.1 3.3-2.1 5.1 0 .9.4 1.6 1 2.2h-9.8c.6-.6 1-1.3 1-2.2 0-1.8-2.1-2.7-2.1-5.1 0-2.6 2.4-4.7 6-4.7z"
        fill="var(--color-accent)"
      />
      <path
        d="M44 30h2.5a6.5 6.5 0 0 1 0 13H44"
        fill="none"
        stroke="var(--color-charcoal)"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M16 28.6h28v11.8A10.6 10.6 0 0 1 33.4 51h-6.8A10.6 10.6 0 0 1 16 40.4V28.6z"
        fill="var(--color-white)"
        stroke="var(--color-charcoal)"
        strokeWidth="3.2"
        strokeLinejoin="round"
      />
      <circle cx="25.5" cy="37" r="2.4" fill="var(--color-charcoal)" />
      <circle cx="34.5" cy="37" r="2.4" fill="var(--color-charcoal)" />
    </svg>
  );
}
